import { UtilsService } from "../../services/utils";

function GeneralTable({ list, setShowModal }: any) {
  return (
    <table
      className="table align-middle table-row-dashed fs-6 gy-5 dataTable"
      id="expenses-table-general"
    >
      <thead>
        <tr
          className="text-start text-muted fw-bold fs-7 text-uppercase gs-0"
          role="row"
        >
          <th
            aria-label="Role: Activate to sort"
            className="min-w-125px "
            colSpan={1}
            rowSpan={1}
            tabIndex={0}
          >
            <span className="" >
              Productor
            </span>
            <span className="dt-column-order" />
          </th>
          <th
            aria-label="Role: Activate to sort"
            className="min-w-125px "
            colSpan={1}
            rowSpan={1}
            tabIndex={0}
          >
            <span className="" >
              Concepto
            </span>
            <span className="dt-column-order" />
          </th>
          <th
            aria-label="Last login: Activate to sort"
            className="min-w-125px "
            colSpan={1}
            rowSpan={1}
            tabIndex={0}
          >
            <span className="" >
              Fecha
            </span>
            <span className="dt-column-order" />
          </th>
          <th
            aria-label="Last login: Activate to sort"
            className="min-w-125px "
            colSpan={1}
            rowSpan={1}
            tabIndex={0}
          >
            <span className="" >
              Monto
            </span>
            <span className="dt-column-order" />
          </th>
          <th
            aria-label="Last login: Activate to sort"
            className="min-w-125px "
            colSpan={1}
            rowSpan={1}
            tabIndex={0}
          >
            <span className="" >
              Observaciones
            </span>
            <span className="dt-column-order" />
          </th>
          <th
            aria-label="Joined Date: Activate to sort"
            className="min-w-125px "
            colSpan={1}
            rowSpan={1}
            tabIndex={0}
          >
            <span className="" >
              Fecha de creación
            </span>
            <span className="dt-column-order" />
          </th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody className="text-gray-600 fw-semibold">
        {list.map((row: any) => (
          <tr key={row._id}>
            <td>
              <p className="text-gray-800 m-0">{row.customer.name} · </p>
              <p className="m-0">Huerta: {row.field.name}</p>
            </td>
            <td>
              <p className="text-gray-800 m-0">{row.concept.name} · </p>
              <p className="m-0 text-capitalize">{row.concept.category}</p>
            </td>
            <td>{UtilsService.dateFormat(row.date, "DD/MM/YYYY")}</td>
            <td>$ {UtilsService.numberFormat(row.amount)}</td>
            <td>{row.comments}</td>
            <td>{UtilsService.dateFormat(row.created_at)}</td>
            <td>
              <button
                className="btn btn-light btn-active-light-primary btn-flex btn-center btn-sm"
                onClick={() =>
                  setShowModal({ data: row, show: true })
                }
              >
                Editar
              </button>
            </td>
          </tr>
        ))}
      </tbody>
      <tfoot />
    </table>
  );
}

export default GeneralTable;
